import Grid from '@mui/material/Grid2';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import VerifiedIcon from '@mui/icons-material/Verified';
import InsightsIcon from '@mui/icons-material/Insights';

const BENEFITS = [
  {
    Icon: SecurityIcon,
    title: "Reducción de riesgos",
    description: "Minimiza errores y evita inconsistencias.",
  },
  {
    Icon: SpeedIcon,
    title: "Ahorro operativo",
    description: "Menos procesos manuales y reprocesos.",
  },
  {
    Icon: VerifiedIcon,
    title: "Confianza en la información",
    description: "Datos validados y verificables.",
  },
  {
    Icon: InsightsIcon,
    title: "Mejora en toma de decisiones",
    description: "Información estructurada y disponible.",
  },
];

function BusinessBenefitsSection() {
  return (
    <section id="beneficios" className="bg-[#F1F5F9]">
      <div className="max-w-[1200px] mx-auto py-96 px-40 text-center">
        <h2 className="text-40 font-extrabold text-[#1E3A8A] mb-64 leading-[1.2]">
          Más que cumplimiento, eficiencia y confianza
        </h2>
        <Grid container spacing={3}>
          {BENEFITS.map(({ Icon, title, description }) => (
            <Grid key={title} size={{ xs: 12, sm: 6, md: 3 }}>
              <div
                className="bg-white rounded-16 py-40 px-28 h-full text-left shadow-[0_2px_12px_rgba(26,86,219,0.07)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-4 hover:shadow-[0_8px_24px_rgba(26,86,219,0.13)]"
                style={{ borderTop: '4px solid #1A56DB' }}
              >
                <Icon className="!text-[4.4rem] text-[#1A56DB] mb-20" />
                <h3 className="text-18 font-bold text-[#1E3A8A] mb-10">{title}</h3>
                <p className="text-16 text-[#475569] leading-[1.65] m-0">{description}</p>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
}

export default BusinessBenefitsSection;
